import { Box, Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverHeader, PopoverTrigger, Text } from "@chakra-ui/react";

export default function Beta(){
    return(
    <Popover trigger="hover">
        <PopoverTrigger>
            <Box cursor="pointer" py={0.5} px={4} maxW="65px" borderRadius={20} background="linear-gradient(0deg, rgba(34,193,195,1) 0%, rgba(105,246,2,1) 100%)">
                <Text fontWeight="black" fontSize="xs" textShadow="1px 1px rgba(0,0,0,0.8)" children="Beta" />
            </Box>
        </PopoverTrigger>
        <PopoverContent>
            <PopoverArrow />
            <PopoverCloseButton />
            <PopoverHeader children="Recurso experimental" />
            <PopoverBody fontSize="sm" children="Isso significa que o recurso que está tentando utilizar está em fase experimental e pode apresentar problemas." />
        </PopoverContent>
    </Popover>
    )
}